import { i18n } from '@/plugins/i18n'

export const dateRangesOverlap = (startA, endA, startB, endB) => {
  const aStartLteBEnd = endB == null || startA == null || startA <= endB
  const aEndGteBStart = endA == null || startB == null || endA >= startB

  return aStartLteBEnd && aEndGteBStart
}

export const getEmployeeChoiceLabel = (employeesChoices, employeeId) => {
  const choice = employeesChoices.find((item) => item.value === employeeId)

  return choice?.text || ''
}

export const buildOccupancyOverlapMessage = ({ employeeName, houseName, roomName }) =>
  i18n.t('employeeOccupancyOverlapAssigned', {
    employeeName,
    houseName: houseName || i18n.t('house'),
    roomName: roomName || i18n.t('room'),
  })

export const findFormOccupancyOverlap = ({
  rooms,
  currentRoomIndex,
  employeeId,
  dateStart,
  dateEnd,
  employeesChoices,
  houseName,
  shineFeaturesEnabled,
}) => {
  const effectiveDateStart = dateStart || new Date().toISOString().slice(0, 10)
  const employeeName = getEmployeeChoiceLabel(employeesChoices, employeeId)

  for (let roomIndex = 0; roomIndex < rooms.length; roomIndex += 1) {
    if (roomIndex === currentRoomIndex) continue

    const room = rooms[roomIndex]
    if (room.occupied || !room.occupants?.includes(employeeId)) continue

    const otherDateStart = shineFeaturesEnabled ? room.dateStart : effectiveDateStart
    if (shineFeaturesEnabled && !otherDateStart) continue

    if (
      !dateRangesOverlap(
        effectiveDateStart,
        dateEnd || null,
        otherDateStart,
        room.dateEnd || null,
      )
    ) {
      continue
    }

    return buildOccupancyOverlapMessage({
      employeeName,
      houseName: houseName || i18n.t('addNewHouse'),
      roomName: room.name,
    })
  }

  return null
}
